import { defineStore } from "pinia"
import { onBeforeMount, onBeforeUnmount, ref } from "vue"

export const useNavigationStore = defineStore("navigation", () => {
    const innerHeight = ref<number>()

    const offset = ref<number>(0)

    const scrollY = ref<number>()

    function handleScrollY(event: {
        data: {
            type: string
            value: number
            offset?: number
            innerHeight?: number
        }
    }) {
        if (event.data.type === "update:scrollY") {
            scrollY.value = event.data.value
            offset.value = event.data.offset ?? 0
            innerHeight.value = event.data.innerHeight
        }
    }

    onBeforeMount(() => {
        // Ecoute sur les changements de scrollY
        window.addEventListener("message", handleScrollY, { passive: true })
    })

    onBeforeUnmount(() => {
        // Supprime l'écouteur de scrollY
        window.removeEventListener("message", handleScrollY)
    })

    /**
     * Réinitialise le store à son état initial.
     */
    function $reset() {
        innerHeight.value = undefined
        offset.value = 0
        scrollY.value = undefined
    }

    return {
        offset,
        innerHeight,
        scrollY,
        $reset,
    }
})
